/**
 * Sky condition model (typically represents a single cloud layer, or clear/obscured, in translated form)
 */
export class SkyCondition {
  /**
   * Cloud base (formatted as a string with a label, and a span tag with a class of "warn" or "alert" if this
   * constitutes a MVFR/IFR ceiling).
   */
  cloudBase: string;

  /**
   * Sky cover (formatted as a string, and a span tag with a class of "warn" or "alert" if this constitutes a MVFR/IFR
   * ceiling).
   */
  skyCover: string;

  /**
   * Parses sky condition from API
   * @param cloudBase
   * @param skyCover
   * @returns {SkyCondition}
   */
  static parse(cloudBase, skyCover): SkyCondition {
    return {
      cloudBase,
      skyCover
    };
  }
}
